/* tslint:disable */

declare var Object: any;
export interface TtadondutyrequestdtlAtdInterface {
  "requestNo": string;
  "companyId": number;
  "destinationNo": number;
  "attendDate": Date;
  "shiftdailycode": string;
  "shiftstarttime": Date;
  "shiftendtime": Date;
  "starttime": Date;
  "endtime": Date;
  "otherStatus"?: string;
  "oldStarttime"?: Date;
  "oldEndtime"?: Date;
}

export class TtadondutyrequestdtlAtd implements TtadondutyrequestdtlAtdInterface {
  "requestNo": string;
  "companyId": number;
  "destinationNo": number;
  "attendDate": Date;
  "shiftdailycode": string;
  "shiftstarttime": Date;
  "shiftendtime": Date;
  "starttime": Date;
  "endtime": Date;
  "otherStatus": string;
  "oldStarttime": Date;
  "oldEndtime": Date;
  constructor(data?: TtadondutyrequestdtlAtdInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `TtadondutyrequestdtlAtd`.
   */
  public static getModelName() {
    return "TtadondutyrequestdtlAtd";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of TtadondutyrequestdtlAtd for dynamic purposes.
  **/
  public static factory(data: TtadondutyrequestdtlAtdInterface): TtadondutyrequestdtlAtd{
    return new TtadondutyrequestdtlAtd(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'TtadondutyrequestdtlAtd',
      plural: 'TtadondutyrequestdtlAtds',
      path: 'TtadondutyrequestdtlAtds',
      properties: {
        "requestNo": {
          name: 'requestNo',
          type: 'string'
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "destinationNo": {
          name: 'destinationNo',
          type: 'number'
        },
        "attendDate": {
          name: 'attendDate',
          type: 'Date'
        },
        "shiftdailycode": {
          name: 'shiftdailycode',
          type: 'string'
        },
        "shiftstarttime": {
          name: 'shiftstarttime',
          type: 'Date'
        },
        "shiftendtime": {
          name: 'shiftendtime',
          type: 'Date'
        },
        "starttime": {
          name: 'starttime',
          type: 'Date'
        },
        "endtime": {
          name: 'endtime',
          type: 'Date'
        },
        "otherStatus": {
          name: 'otherStatus',
          type: 'string'
        },
        "oldStarttime": {
          name: 'oldStarttime',
          type: 'Date'
        },
        "oldEndtime": {
          name: 'oldEndtime',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/TtadondutyrequestdtlAtd.ts